(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["diabetic-calculator"] && !window.DesignMode) return;
  try {
    
window.saDiabeticCalculator = [
  {
    "name": "Baby Dolphins",
    "id": 1685208753388,
    "weight": 3.1,
    "carbs": 2.3,
    "sugars": 2.2
  },
  {
    "name": "Haribo Jelly Babies",
    "id": 1685209038317,
    "weight": 2.8,
    "carbs": 2.3,
    "sugars": 1.9
  },
  {
    "name": "Haribo Giant Snakes",
    "id": 1685209038318,
    "weight": 63.5,
    "carbs": 50.1,
    "sugars": 33.6
  },
  {
    "name": "Haribo Giant Strawberries",
    "id": 1685209038319,
    "weight": 10.1,
    "carbs": 8.3,
    "sugars": 4.2
  },
  {
    "name": "Barratt Jelly Beans",
    "id": 1685209038320,
    "weight": 6.4,
    "carbs": 5.0,
    "sugars": 4.3
  },
  {
    "name": "Twisty Marshmallows Mix",
    "id": 1685209038321,
    "weight": "",
    "carbs": "",
    "sugars": ""
  },
  {
    "name": "Jelly Giants",
    "id": 1685209038322,
    "weight": 6.4,
    "carbs": 5.0,
    "sugars": 4.3
  },
  {
    "name": "Swizzlers Mix",
    "id": 1685209038323,
    "weight": "",
    "carbs": "",
    "sugars": ""
  },
  {
    "name": "Apple Pencils",
    "id": 1685209038324,
    "weight": 11.4,
    "carbs": 9.9,
    "sugars": 7.6
  },
  {
    "name": "Blue Raspberry Pencils",
    "id": 1685209038325,
    "weight": 12.4,
    "carbs": 10.8,
    "sugars": 8.3
  },
  {
    "name": "Bubblegum Pencils",
    "id": 1685209038326,
    "weight": 12.0,
    "carbs": 10.6,
    "sugars": 7.6
  },
  {
    "name": "Strawberry Pencils",
    "id": 1685209038327,
    "weight": 13.4,
    "carbs": 11.6,
    "sugars": 9.1
  },
  {
    "name": "Fizzy Strawberry Pencils",
    "id": 1685209038328,
    "weight": 12.5,
    "carbs": 11.0,
    "sugars": 8.7
  },
  {
    "name": "Fizzy Strawberry Bites",
    "id": 1685209038329,
    "weight": 4.5,
    "carbs": 3.8,
    "sugars": 3.0
  },
  {
    "name": "Strawberry Pencil Bites",
    "id": 1685209038330,
    "weight": 3.2,
    "carbs": 2.7,
    "sugars": 2.1
  },
  {
    "name": "Water Melon Slices",
    "id": 1685209038331,
    "weight": 6.4,
    "carbs": 5.2,
    "sugars": 3.6
  },
  {
    "name": "Cola Bottles",
    "id": 1685209038332,
    "weight": 4.2,
    "carbs": 3.0,
    "sugars": 3.0
  },
  {
    "name": "Giant Cola Bottles",
    "id": 1685209038333,
    "weight": 25.1,
    "carbs": 19.4,
    "sugars": 11.6
  },
  {
    "name": "Fizzy Cola Bottle",
    "id": 1685209038334,
    "weight": 3.4,
    "carbs": 2.9,
    "sugars": 2.0
  },
  {
    "name": "Twin Cherries",
    "id": 1685209038335,
    "weight": 9.2,
    "carbs": 6.9,
    "sugars": 6.7
  },
  {
    "name": "Tongue Painters",
    "id": 1685209038336,
    "weight": 9.2,
    "carbs": 7.7,
    "sugars": 5.1
  },
  {
    "name": "Fizzy Twin Cherries",
    "id": 1685209038337,
    "weight": 10.2,
    "carbs": 8.7,
    "sugars": 5.9
  },
  {
    "name": "Fizzy Dummies",
    "id": 1685209038338,
    "weight": 5.3,
    "carbs": 4.5,
    "sugars": 3.1
  },
  {
    "name": "Fizzy Dummy Tongue Painter",
    "id": 1685209038339,
    "weight": 10.0,
    "carbs": 8.5,
    "sugars": 5.8
  },
  {
    "name": "Red Candy Rolls",
    "id": 1685209038340,
    "weight": 35.8,
    "carbs": 29.4,
    "sugars": 22.2
  },
  {
    "name": "Apple Bon Bons",
    "id": 1688928502365,
    "weight": "",
    "carbs": "",
    "sugars": ""
  },
  {
    "name": "Blue Raspberry Bon Bons",
    "id": 1685209038341,
    "weight": 4.1,
    "carbs": 3.5,
    "sugars": 2.5
  },
  {
    "name": "Strawberry Bon Bons",
    "id": 1685209038342,
    "weight": 4.1,
    "carbs": 3.5,
    "sugars": 2.5
  },
  {
    "name": "Midget Gems",
    "id": 1685209038343,
    "weight": 2.3,
    "carbs": 1.8,
    "sugars": 1.2
  },
  {
    "name": "Wine Gums",
    "id": 1685209038344,
    "weight": 5.5,
    "carbs": 4.3,
    "sugars": 2.8
  },
  {
    "name": "Jumbo Fizzy Cherry Cola Bottle",
    "id": 1685209038345,
    "weight": 24.8,
    "carbs": 19.1,
    "sugars": 15.4
  },
  {
    "name": "Fizzy Cherry Cola Bottle",
    "id": 1685209038346,
    "weight": 3.5,
    "carbs": 2.9,
    "sugars": 2.0
  },
  {
    "name": "Fizzy Bubblegum Bottle",
    "id": 1685209038347,
    "weight": 7.6,
    "carbs": 5.9,
    "sugars": 4.7
  },
  {
    "name": "Jumbo Fizzy Bubblegum Bottle",
    "id": 1685209038348,
    "weight": 22.5,
    "carbs": 17.3,
    "sugars": 13.9
  },
  {
    "name": "Large Fizzy Bubblegum Bottle",
    "id": 1685209038349,
    "weight": 7.6,
    "carbs": 5.8,
    "sugars": 4.7
  },
  {
    "name": "Fizzy Peach Rings",
    "id": 1685209038350,
    "weight": "",
    "carbs": "",
    "sugars": ""
  },
  {
    "name": "Giant Dolphins",
    "id": 1685209038351,
    "weight": 39.3,
    "carbs": 30.2,
    "sugars": 22.8
  },
  {
    "name": "Chamallows Mini Pink & White",
    "id": 1685209038352,
    "weight": 0.3,
    "carbs": 0.2,
    "sugars": 0.2
  },
  {
    "name": "Mini Foam Bananas",
    "id": 1685209038353,
    "weight": 2.3,
    "carbs": 2.1,
    "sugars": 1.9
  },
  {
    "name": "Rainbow Pencil Bites",
    "id": 1685209038356,
    "weight": 4.0,
    "carbs": 3.4,
    "sugars": 2.5
  },
  {
    "name": "Jelly Sharks",
    "id": 1685209038357,
    "weight": 6.0,
    "carbs": 4.5,
    "sugars": 3.3
  },
  {
    "name": "Swirly Fish",
    "id": 1685209038358,
    "weight": 6.0,
    "carbs": 4.6,
    "sugars": 3.2
  },
  {
    "name": "Giant Gummy Spiders",
    "id": 1685209038359,
    "weight": 39.2,
    "carbs": 29.0,
    "sugars": 21.6
  },
  {
    "name": "Chicken Feet",
    "id": 1685209038360,
    "weight": 6.1,
    "carbs": 4.8,
    "sugars": 3.4
  },
  {
    "name": "Mini Chocolate Eggs",
    "id": 1685209038361,
    "weight": 3.4,
    "carbs": 2.4,
    "sugars": 2.4
  },
  {
    "name": "Snowies",
    "id": 1685209038362,
    "weight": 1.8,
    "carbs": 1.3,
    "sugars": 1.0
  },
  {
    "name": "White Chocolate Mice",
    "id": 1685209038363,
    "weight": 5.4,
    "carbs": 3.6,
    "sugars": 2.9
  },
  {
    "name": "Milk Chocolate Beans",
    "id": 1685209038364,
    "weight": 0.6,
    "carbs": 0.5,
    "sugars": 0.4
  },
  {
    "name": "Milk Chocolate Peanuts",
    "id": 1685209038365,
    "weight": 2.8,
    "carbs": 0.9,
    "sugars": 0.9
  },
  {
    "name": "Milk Chocolate Raisins",
    "id": 1685209038366,
    "weight": 2.1,
    "carbs": 1.3,
    "sugars": 1.3
  },
  {
    "name": "Gummy Monkeys",
    "id": 1685209038367,
    "weight": 20.5,
    "carbs": 15.8,
    "sugars": 11.3
  },
  {
    "name": "BUBS Bubblegum Skulls",
    "id": 1685209038368,
    "weight": 13.9,
    "carbs": 13.5,
    "sugars": 8.5
  },
  {
    "name": "Strawberry & Cream Jellies",
    "id": 1685209038369,
    "weight": 7.6,
    "carbs": 5.6,
    "sugars": 3.9
  },
  {
    "name": "Rhubarbs & Custards",
    "id": 1688928715881,
    "weight": "",
    "carbs": "",
    "sugars": ""
  },
  {
    "name": "Crocodiles",
    "id": 1689009793074,
    "weight": "",
    "carbs": "",
    "sugars": ""
  },
  {
    "name": "Strawberry Paint Balls",
    "id": 1688928717046,
    "weight": "",
    "carbs": "",
    "sugars": ""
  },
  {
    "name": "Peach Paint Balls",
    "id": 1689009794290,
    "weight": "",
    "carbs": "",
    "sugars": ""
  }
];
  
document.addEventListener('DOMContentLoaded', function() {
  var diabeticCalculator = document.querySelector('.diabetic-calculator tbody');

  window.saDiabeticCalculator.forEach(function(sweet, index) {
    if (!sweet.carbs || sweet.carbs === '') {
      return;
    }

    var calculatorNewRow = document.createElement('tr');

    var selectorCell = document.createElement('td');
    selectorCell.innerHTML = '<input type="checkbox" class="select-row" />';

    calculatorNewRow.appendChild(selectorCell);

    ['name', 'carbs', 'sugars'].forEach(function(attribute) {
      var newCell = document.createElement('td');
      
      newCell.innerText = sweet[attribute];

      calculatorNewRow.appendChild(newCell);
    });

    diabeticCalculator.appendChild(calculatorNewRow);
  });
  
  var checkboxes = document.querySelectorAll('.select-row');
  
  checkboxes.forEach(function(checkbox, index) {
    checkbox.addEventListener('change', function() {
      var row = this.closest('tr');
      var printableSection = document.querySelector('#diabetic-calculator-printable-section tbody');
      var newRow = document.createElement('tr');
      var cells = Array.from(row.children).slice(1);

      cells.forEach(function(cell) {
        var newCell = document.createElement('td');
        
        newCell.innerText = cell.innerText;
        
        newRow.appendChild(newCell);
      });

      newRow.dataset.id = index;

      if (this.checked) {
        printableSection.appendChild(newRow);
      } else {
        var rows = Array.from(printableSection.querySelectorAll('tr'));
        
        var matchedRow = rows.find(function(r) {
          return r.dataset.id === newRow.dataset.id;
        });

        if (matchedRow) {
          printableSection.removeChild(matchedRow);
        }
      }
    });
  });

  // Update print behavior
  var printButton = document.querySelector('.diabetic-calculator button');
  
  printButton.addEventListener('click', function() {
    var calculatorSection = document.querySelector('.diabetic-calculator');
    var selectedSweetsSection = document.querySelector('.diabetic-calculator .printable-section');
    
    var calculatorHTML = selectedSweetsSection.outerHTML;
  
    var printWindow = window.open('', '_blank');
    
    var printContent = '<html><head><title>Diabetic Sweet Calculator - Print Preview</title><style>' + `
  .printable-section {
    border: 2px solid #FF58A8;
    margin: 0 auto;
    padding: 2rem;
  }

  .printable-section h2 {
    text-align: center;
  }

  .printable-section table {
    margin: 0 auto;
  }

  .printable-section th,
  .printable-section td {
    font-weight: bold;
    text-align: center;
    font-size: 16px;
    border: 1px solid #ddd;
    padding: 8px;
  }` + '</style></head><body>' + 
      calculatorHTML + '</body></html>';
    
    printWindow.document.open();
    printWindow.document.write(printContent);
    printWindow.document.close();
    
    printWindow.onload = function() {
      printWindow.print();
    };
    
    calculatorSection.classList.remove('print-hidden');
    
    selectedSweetsSection.classList.remove('selected-sweets-visible');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

})();
